export default __webpack_public_path__ + "static/media/narkha.16cd6dea.png";